import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Bot, User } from "lucide-react";

interface Props {
  role: "user" | "assistant";
  content: string;
}

export default function ChatMessage({ role, content }: Props) {
  const isUser = role === "user";

  return (
    <div className={`flex gap-3 ${isUser ? "flex-row-reverse" : ""}`}>
      <div
        className={`w-8 h-8 rounded-xl shrink-0 flex items-center justify-center ${
          isUser
            ? "bg-citilux-blue-600/20 text-citilux-blue-400"
            : "bg-navy-700 text-metallic-silver"
        }`}
      >
        {isUser ? <User className="w-4 h-4" /> : <Bot className="w-4 h-4" />}
      </div>

      <div
        className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${
          isUser
            ? "bg-citilux-blue-600 text-white"
            : "bg-white dark:bg-navy-800/60 border border-light-border dark:border-navy-700/40 text-gray-800 dark:text-white/90"
        }`}
      >
        {isUser ? (
          <p className="whitespace-pre-wrap">{content}</p>
        ) : (
          <div className="prose prose-sm dark:prose-invert max-w-none prose-table:text-xs prose-th:bg-gray-100 dark:prose-th:bg-navy-700 prose-th:px-2 prose-th:py-1 prose-td:px-2 prose-td:py-1 prose-td:border prose-th:border prose-th:border-light-border dark:prose-th:border-navy-600 prose-td:border-light-border dark:prose-td:border-navy-600 prose-headings:text-gray-900 dark:prose-headings:text-white">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
}
